// extracted by mini-css-extract-plugin
export var deliveryRow = "_te-a";
export var fixedHeight = "_te-4";
export var freightLogo = "_te-9";
export var fullWidth = "_te-3";
export var priceColumn = "_te-5";
export var radioSelected = "_te-7";
export var radioUnselected = "_te-6";
export var selectedOption = "_te-2";
export var selectedOptionContainer = "_te-1";
export var selection = "_te-0";
export var tallSkeletonText = "_te-8";